import { render, staticRenderFns } from "./sub-admin-vue.vue?vue&type=template&id=7c008aaa&scoped=true&"
import script from "./sub-admin-vue.vue?vue&type=script&lang=js&"
export * from "./sub-admin-vue.vue?vue&type=script&lang=js&"
import style0 from "./sub-admin-vue.vue?vue&type=style&index=0&id=7c008aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c008aaa",
  null
  
)

export default component.exports